import React from 'react';
import Translate from "../../../../../../../components/Translate";
import {setAfkConfigByCompanyId} from "../../../../../../../services/company/api";
import InputText from "../../../../../../../components/input-text";
import {isPositiveInteger, silverInfoStyles} from "../../../../../../../utils/General";

const style = {
    inputStyle: {
        width: '95px',
        border: 'none',
        height: '38px'
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '76px',
        border: '1px solid #A4ADC1',
        height: '40px',
        width: '147px',
        borderRadius: '10px',
        marginTop: '10px'
    },
}

const ChatInactivityAction = ({client, afkConfig, setAfkConfig}) => {
    const handleEnabledCheckboxChange = (event) => {
        const newValue = event.target.checked;
        setAfkConfig({...afkConfig, enabled: newValue});
        afkConfig.enabled = newValue;
        setAfkConfigByCompanyId(client.id, {...afkConfig, enabled: newValue});
    };

    const handleAfkTimeInputChange = (newValue) => {
        setAfkConfig({...afkConfig, afkTime: newValue});
        afkConfig.afkTime = newValue;
        setAfkConfigByCompanyId(client.id, {...afkConfig, afkTime: newValue});
    }

    const validate = (value) => {
        isPositiveInteger(value);
        const parsedValue = Number(value);
        if (parsedValue < 1 || parsedValue > 60) {
            throw new Error('Wrong Range');
        }
    };

    return (
        <div style={{padding: '5px', margin: '10px'}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                    <Translate text={'afkConfigs'}/>
                </h2>
                <div style={{display: 'flex'}}>
                    <label className="switch controller">
                        <input
                            type="checkbox"
                            checked={afkConfig.enabled}
                            onChange={handleEnabledCheckboxChange}
                        />
                        <span className="slider round"/>
                    </label>
                    <h2 style={silverInfoStyles.info}>
                        <Translate text="enable/disable"/>
                    </h2>
                </div>
                {afkConfig.enabled && (
                    <React.Fragment>
                        <div style={{marginLeft: '74px', marginTop: '20px'}}>
                            <span style={{...silverInfoStyles.info, marginLeft: '0'}}>
                                <Translate text="afkTimeDescription"/>
                            </span>
                            <div style={{...style.inputWrapper, marginLeft: '0'}}>
                                <InputText
                                    inputStyles={style.inputStyle}
                                    value={afkConfig.afkTime}
                                    validate={validate}
                                    handleChange={(event) => handleAfkTimeInputChange(event)}
                                    defaultValue={afkConfig.afkTime}
                                />
                                <div style={style.textDivStyle}>
                                    <p><Translate text={'min'}/></p>
                                </div>
                            </div>
                        </div>

                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default ChatInactivityAction;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/ChatInactivityAction.jsx